type CompareEnv = Record<string, string | undefined>;

/**
 * Explicit property read (not a bare `import.meta.env`) so Vite inlines it
 * and the Jest transform can map it.
 */
function currentEnv(): CompareEnv {
  return {
    VITE_FEATURE_COMPARE: import.meta.env.VITE_FEATURE_COMPARE,
  };
}

/** #140: the compare UI is on only where the flag is set (local dev, e2e). */
export function isCompareEnabled(env: CompareEnv = currentEnv()): boolean {
  return env.VITE_FEATURE_COMPARE === 'true';
}
